import React, { Component } from "react";
import { DatePicker, Select, Spin, message, Radio, Space } from "antd";
import Bridge from "../../../../utils/Bridge";
import dayjs from "dayjs";
import moment from "moment";
import {
  LE_STUDY_DEMOGRAPHICS_CONTENT,
  RESEARCH_TYPE,
  US_STATES,
} from "../../../../utils/consts";

import englishJson from "../../../../utils/language/leStudy/english.json";
import spanishJson from "../../../../utils/language/leStudy/spanish.json";

const { Option } = Select;

export default class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: "",
      last_name: "",
      middle_name: "",
      date_of_birth: null,
      loading: false,
      current_age: "",
      relationship_with_als: "",
      relationship_with_als_specification: "",
      place_of_birth_country: "",
      place_of_birth_city_province: "",
      place_of_birth_state: "",
      place_of_birth_other_country: "",
    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.le_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.parent_field === "First Name") {
                this.setState({ first_name: item.value });
              }
              if (item.parent_field === "Middle Name") {
                this.setState({ middle_name: item.value });
              }
              if (item.parent_field === "Last Name") {
                this.setState({ last_name: item.value });
              }
              if (item.parent_field === "Date of Birth") {
                this.setState({
                  date_of_birth: item.value ? dayjs(item.value) : null,
                });
              }
              if (item.parent_field === "Current Age") {
                this.setState({ current_age: item.value });
              }
              if (
                item.parent_field ===
                "Are you a caregiver or family member of a patient with ALS?"
              ) {
                this.setState({ relationship_with_als: item.value });
              }
              if (item.parent_field === "Caregiver Relationship") {
                this.setState({
                  relationship_with_als_specification: item.value,
                });
              }
              if (item.parent_field === "Place of Birth Country") {
                this.setState({ place_of_birth_country: item.value });
              }
              if (item.parent_field === "Place of Birth City/Province") {
                this.setState({ place_of_birth_city_province: item.value });
              }
              if (item.parent_field === "Place of Birth State") {
                this.setState({ place_of_birth_state: item.value });
              }
              if (item.parent_field === "Place of Birth Other Country") {
                this.setState({ place_of_birth_other_country: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    let dob = dayjs(date).format("YYYY-MM-DD");
    const calculatedAge = moment().diff(moment(dob), "years");
    this.setState({
      date_of_birth: date,
      current_age: calculatedAge,
    });
  };
  validateName = (field, label) => {
    // Check if the input contains only alphabetic characters
    // if (!/^[A-Za-z]+$/.test(field)) {
    //   // message.warning(`${label} can only contain alphabetic characters.`);
    //   return `${label} can only contain alphabetic characters.`;
    // }
    // Check if the length of the input is within a specific range
    if (field.length <= 2 || field.length > 30) {
      // message.warning(`${label} must be between 2 and 30 characters long.`);
      return `${label} must be between 2 and 30 characters long.`;
    }
    return 1;
  };
  // step 1
  save_details = () => {
    if (!this.state.first_name) {
      message.warning("First name is required");
      return;
    }
    const validateFirstName = this.validateName(
      this.state.first_name,
      "First Name"
    );
    if (validateFirstName != 1) {
      message.warning(validateFirstName);
      return;
    }
    if (!this.state.last_name) {
      message.warning("Last name is required");
      return;
    }
    const validateLastName = this.validateName(
      this.state.last_name,
      "Last Name"
    );
    if (validateLastName != 1) {
      message.warning(validateLastName);
      return;
    }
    if (!this.state.date_of_birth) {
      message.warning("Date of birth is required");
      return;
    }
    let last18YearsStartDate = moment().subtract(18, "years");
    last18YearsStartDate = moment(last18YearsStartDate).format("YYYY-MM-DD");
    let dob2 = dayjs(this.state.date_of_birth).format("YYYY-MM-DD");
    if (dob2 > last18YearsStartDate) {
      message.warning(
        "Min Age must be 18 Years. Please select valid Date Of birth"
      );
      return;
    }

    if (!this.state.current_age) {
      message.warning("Current age is required");
      return;
    }
    if (!this.state.place_of_birth_country) {
      message.warning("Place of Birth is required");
      return;
    }
    if (this.state.place_of_birth_country == "US") {
      if (!this.state.place_of_birth_city_province) {
        message.warning("City/Province is required");
        return;
      }
      if (!this.state.place_of_birth_state) {
        message.warning("State is required");
        return;
      }
    }
    if (this.state.place_of_birth_country == "Other") {
      if (!this.state.place_of_birth_city_province) {
        message.warning("City/Province is required");
        return;
      }
      if (!this.state.place_of_birth_state) {
        message.warning("State is required");
        return;
      }
      if (!this.state.place_of_birth_other_country) {
        message.warning("Country is required");
        return;
      }
    }
    if (!this.state.relationship_with_als) {
      message.warning(
        "Please select the 'Are you a caregiver or family member of a patient with ALS' field "
      );
      return;
    }
    if (
      this.state.relationship_with_als == "Yes" &&
      !this.state.relationship_with_als_specification
    ) {
      message.warning("Relationship with ALS specification is required");
      return;
    }
    let dob = dayjs(this.state.date_of_birth).format("MM/DD/YYYY");
    let questions = [
      {
        parent_field: "First Name",
        field: "First Name",
        value: this.state.first_name,
      },
      {
        parent_field: "Middle Name",
        field: "Middle Name",
        value: this.state.middle_name,
      },
      {
        parent_field: "Last Name",
        field: "Last Name",
        value: this.state.last_name,
      },
      {
        parent_field: "Date of Birth",
        field: "Date of Birth",
        value: this.state.date_of_birth ? dob : "",
      },
      {
        parent_field: "Current Age",
        field: "Current Age",
        value: this.state.current_age,
      },
      {
        parent_field: "Place of Birth Country",
        field: "Place of Birth Country",
        value: this.state.place_of_birth_country,
      },
      {
        parent_field: "Place of Birth City/Province",
        field: "Place of Birth City/Province",
        value: this.state.place_of_birth_city_province,
      },
      {
        parent_field: "Place of Birth State",
        field: "Place of Birth State",
        value: this.state.place_of_birth_state,
      },
      {
        parent_field: "Place of Birth Other Country",
        field: "Place of Birth Other Country",
        value: this.state.place_of_birth_other_country,
      },
      {
        parent_field:
          "Are you a caregiver or family member of a patient with ALS?",
        field: "Are you a caregiver or family member of a patient with ALS?",
        value: this.state.relationship_with_als,
        subId:
          LE_STUDY_DEMOGRAPHICS_CONTENT.find(
            (item) => item.field == "isCaregiverOfALS"
          )?.content.find(
            (item) =>
              item.subtitle.toLocaleLowerCase() ==
              this.state.relationship_with_als.toLocaleLowerCase()
          )?.subId || "",
      },
      {
        parent_field: "Caregiver Relationship",
        field: "Caregiver Relationship",
        value: this.state.relationship_with_als_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "1",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.le_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          const formData =
            RESEARCH_TYPE == "LE Study"
              ? this.props.language == "English"
                ? englishJson
                : spanishJson
              : englishJson;
          message.success(
            formData.page.demographicQuestions.messages
              .demographicsDataAddedSuccessfully
          );
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(3);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    const formData =
      RESEARCH_TYPE == "LE Study"
        ? this.props.language == "English"
          ? englishJson
          : spanishJson
        : englishJson;
    return (
      <div>
        <div className="header">
          <h3>
            {
              formData.page.demographicQuestions.fields.personalDetails
                .innerTitle
            }
          </h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <p className="manadatory-note">
              <strong className="text-danger">
                {formData.page.demographicQuestions.note}:
              </strong>{" "}
              {formData.page.demographicQuestions.allFieldsMandatory}
            </p>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .firstName
                }
              </label>
              <br />
              <input
                type="text"
                name="first_name"
                value={this.state.first_name}
                onChange={(e) => this.setState({ first_name: e.target.value })}
                maxLength={30}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .middleName
                }{" "}
                {formData.page.demographicQuestions.fields.personalDetails.optional}
              </label>
              <br />
              <input
                type="text"
                name="middle_name"
                value={this.state.middle_name}
                maxLength={30}
                onChange={(e) => this.setState({ middle_name: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .lastName
                }
              </label>
              <br />
              <input
                type="text"
                name="last_name"
                value={this.state.last_name}
                onChange={(e) => this.setState({ last_name: e.target.value })}
                maxLength={30}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .dateOfBirth
                }{" "}
                (MM/DD/YYYY)
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/DD/YYYY"}
                disabledDate={disabledDate}
                value={this.state.date_of_birth}
                placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectDate}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .currentAge
                }
              </label>
              <br />
              <input
                type="number"
                name="current_age"
                value={this.state.current_age}
                onChange={(e) => this.setState({ current_age: e.target.value })}
                maxLength={3}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .placeOfBirth
                }
              </label>
              <br />
              <Select
                onChange={(value) =>
                  this.setState({
                    place_of_birth_country: value,
                    place_of_birth_city_province: "",
                    place_of_birth_state: "",
                    place_of_birth_other_country: "",
                  })
                }
                value={this.state.place_of_birth_country}
                className="col-lg-12"
                style={{ height: 55, maxWidth: 500 }}
                placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectCountry}
              >
                <Option value="">{formData.page.demographicQuestions.fields.personalDetails.placeholders.select}</Option>
                <Option value="US">US</Option>
                <Option value="Other">Other</Option>
              </Select>
            </div>
            {this.state.place_of_birth_country == "US" && (
              <>
                <div className="form-group">
                  <label className="mb-2 input-heading">
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .cityProvince
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="place_of_birth_city_province"
                    value={this.state.place_of_birth_city_province}
                    onChange={(e) =>
                      this.setState({
                        place_of_birth_city_province: e.target.value,
                      })
                    }
                    placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.cityProvince}
                    style={{ maxWidth: 500 }}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-2 input-heading">
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .state
                    }
                  </label>
                  <br />
                  <Select
                    onChange={(value) =>
                      this.setState({
                        place_of_birth_state: value,
                      })
                    }
                    value={this.state.place_of_birth_state}
                    className="col-lg-12"
                    style={{ height: 55, maxWidth: 500 }}
                    placeholder={formData.page.demographicQuestions.fields.personalDetails.placeholders.selectState}
                  >
                    <Option value="">{formData.page.demographicQuestions.fields.personalDetails.placeholders.select}</Option>
                    {US_STATES.map((state, index) => (
                      <Option key={index} value={state}>
                        {state}
                      </Option>
                    ))}
                  </Select>
                </div>
              </>
            )}
            {this.state.place_of_birth_country == "Other" && (
              <>
                <div className="form-group">
                  <label className="mb-2 input-heading">
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .cityProvince
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="place_of_birth_city_province"
                    value={this.state.place_of_birth_city_province}
                    onChange={(e) =>
                      this.setState({
                        place_of_birth_city_province: e.target.value,
                      })
                    }
                    placeholder={
                      formData.page.demographicQuestions.fields.personalDetails
                        .cityProvince
                    }
                    style={{ maxWidth: 500 }}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-2 input-heading">
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .state
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="place_of_birth_state"
                    value={this.state.place_of_birth_state}
                    onChange={(e) =>
                      this.setState({
                        place_of_birth_state: e.target.value,
                      })
                    }
                    placeholder={
                      formData.page.demographicQuestions.fields.personalDetails
                        .state
                    }
                    style={{ maxWidth: 500 }}
                  />
                </div>
                <div className="form-group">
                  <label className="mb-2 input-heading">
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .country
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="place_of_birth_other_country"
                    value={this.state.place_of_birth_other_country}
                    onChange={(e) =>
                      this.setState({
                        place_of_birth_other_country: e.target.value,
                      })
                    }
                    placeholder={
                      formData.page.demographicQuestions.fields.personalDetails
                        .country
                    }
                    style={{ maxWidth: 500 }}
                  />
                </div>
              </>
            )}
            <div className="form-group">
              <label className="input-heading">
                {
                  formData.page.demographicQuestions.fields.personalDetails
                    .areYouCaregiver
                }
              </label>
              <br />
              <Radio.Group
                onChange={(e) =>
                  this.setState({
                    relationship_with_als: e.target.value,
                  })
                }
                value={this.state.relationship_with_als}
                direction="vertical"
              >
                <Space direction="horizontal">
                  {
                    formData.page.demographicQuestions.fields.personalDetails
                      .yes
                  }
                  <Radio value={"Yes"}>
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .yes
                    }
                  </Radio>
                  {formData.page.demographicQuestions.fields.personalDetails.no}
                  <Radio value={"No"}>
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .no
                    }
                  </Radio>
                </Space>
              </Radio.Group>
              {this.state.relationship_with_als == "Yes" && (
                <div className="form-group mt-3">
                  <label className="input-heading">
                    {
                      formData.page.demographicQuestions.fields.personalDetails
                        .areYouCaregiverSpecification
                    }
                  </label>
                  <br />
                  <input
                    type="text"
                    name="relationship_with_als"
                    value={this.state.relationship_with_als_specification}
                    onChange={(e) =>
                      this.setState({
                        relationship_with_als_specification: e.target.value,
                      })
                    }
                  />
                </div>
              )}
            </div>
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  {formData.page.demographicQuestions.button.save}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    background: "#b3b3b3",
                    cursor: "auto",
                  }}
                  className="submit-button"
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.demographicQuestions.button.previous}
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save_details()}
                >
                  {formData.page.demographicQuestions.button.savenext}{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
